<template>
  <PageLayout class="telegram-bot-page">
    <PageTitle>Мій Telegram-бот</PageTitle>
    <div class="telegram-bot-page__content">
      <SpinnerLoader v-if="isLoadingLink" :scale="2" color="#EB883B" />
      <TelegramBotLinked v-else-if="isLinked" :username="telegramUsername" />
      <TelegramBotError v-else-if="error" :message="error" @retry="initLink" />
      <TelegramBotPending v-else :link="link" :qr-code="qrCode" />
    </div>
  </PageLayout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { pages } from '@/entities/current-page';
import { TelegramBotError, TelegramBotLinked, TelegramBotPending } from '@/features/telegram-bot';
import { PageLayout } from '@/shared/ui/layouts';
import { SpinnerLoader } from '@/shared/ui/loader';
import { PageTitle } from '@/shared/ui/page-title';

export default {
  components: { PageLayout, PageTitle, SpinnerLoader, TelegramBotPending, TelegramBotLinked, TelegramBotError },
  computed: {
    ...mapGetters('telegramBotModule', [
      'link', 'qrCode', 'isLinked', 'telegramUsername', 'isLoadingLink', 'error',
    ]),
  },
  created() {
    this.changeActivePage(pages.RESOURCES);
    this.initLink();
  },
  beforeDestroy() {
    this.stopPolling();
  },
  methods: {
    ...mapActions('currentPageModule', ['changeActivePage']),
    ...mapActions('telegramBotModule', ['initLink', 'stopPolling']),
  },
};
</script>

<style lang="scss" scoped>
.telegram-bot-page {
  font-family: 'Geist', sans-serif;
  font-size: 14px;
  color: #09090B;

  &__content {
    display: flex;
    justify-content: center;
    padding: 24px 0;
  }
}
</style>
